<div class="row">
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-body px-3 py-3">
                <div class="font-size-lg pb-3">
                    <a [routerLink]="">
                        Sketch mockups creation
                    </a>
                </div>
                <div>
                    <div class="avatar-icon-wrapper avatar-initials avatar-icon-sm">
                        <div class="avatar-icon rounded text-white bg-warning">
                            JK
                        </div>
                    </div>
                    <div class="avatar-icon-wrapper avatar-initials avatar-icon-sm">
                        <div class="avatar-icon rounded text-white bg-dark">
                            HA
                        </div>
                        <span class="badge badge-circle badge-success">Online</span>
                    </div>
                    <div class="avatar-icon-wrapper avatar-icon-sm">
                        <div class="avatar-icon rounded">
                            <img alt="..." src="assets/images/avatars/avatar2.jpg"/>
                        </div>
                    </div>
                    <div class="avatar-icon-wrapper avatar-icon-sm">
                        <div class="avatar-icon rounded">
                            <img alt="..." src="assets/images/avatars/avatar1.jpg"/>
                        </div>
                        <span class="badge badge-circle badge-warning">Idle</span>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex align-items-center p-2 justify-content-between">
                <div>
                    <button class="btn btn-sm btn-outline-first px-2 border-0" type="button">
                        <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                    </button>
                    <span class="font-size-sm text-black-50 px-2"
                         tooltip="Total downloads"
                    >
                        <fa-icon [icon]="['fas', 'link']" class="mr-1"></fa-icon>
                        55
                    </span>
                    <span class="font-size-sm text-black-50 px-2"
                         tooltip="Total views"
                    >
                        <fa-icon [icon]="['far', 'eye']" class="mr-1"></fa-icon>
                        344
                    </span>
                </div>
                <div class="font-size-sm px-2">
                    <fa-icon [icon]="['far', 'clock']" class="mr-1"></fa-icon>
                    Today - 11:35
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5 bg-royal text-white border-0">
            <div class="card-body px-3 py-3">
                <div class="font-size-lg pb-3">
                    <a [routerLink]="" class="text-white">
                        Photoshop design
                    </a>
                </div>
                <div>
                    <div class="avatar-icon-wrapper avatar-initials avatar-icon-sm">
                        <div class="avatar-icon rounded text-white bg-warning shadow-none">
                            JK
                        </div>
                    </div>
                    <div class="avatar-icon-wrapper avatar-initials avatar-icon-sm">
                        <div class="avatar-icon rounded text-white bg-dark shadow-none">
                            HA
                        </div>
                        <span class="badge badge-circle badge-success">Online</span>
                    </div>
                    <div class="avatar-icon-wrapper avatar-icon-sm">
                        <div class="avatar-icon rounded shadow-none">
                            <img alt="..." src="assets/images/avatars/avatar2.jpg"/>
                        </div>
                    </div>
                    <div class="avatar-icon-wrapper avatar-icon-sm">
                        <div class="avatar-icon rounded shadow-none">
                            <img alt="..." src="assets/images/avatars/avatar1.jpg"/>
                        </div>
                        <span class="badge badge-circle badge-warning">Idle</span>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex align-items-center px-2 pb-2 pt-0 bg-royal border-0 justify-content-between">
                <div>
                    <a [routerLink]="" class="btn btn-sm btn-outline-first text-white px-2 border-0"

                      tooltip="Actions menu">
                        <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                    </a>
                    <span class="font-size-sm text-white-50 px-2"
                         tooltip="Total downloads"
                    >
                        <fa-icon [icon]="['fas', 'link']" class="mr-1"></fa-icon>
                        55
                    </span>
                    <span class="font-size-sm text-white-50 px-2"
                         tooltip="Total views"
                    >
                        <fa-icon [icon]="['far', 'eye']" class="mr-1"></fa-icon>
                        344
                    </span>
                </div>
                <div class="font-size-sm px-2">
                    <fa-icon [icon]="['far', 'clock']" class="mr-1"></fa-icon>
                    Today - 11:35
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5 text-dark card-box-border-bottom border-warning">
            <div class="card-body px-3 py-3">
                <div class="font-size-lg pb-3">
                    <a [routerLink]="">
                        Angular implementation
                    </a>
                </div>
                <div>
                    <div class="avatar-icon-wrapper avatar-initials avatar-icon-sm">
                        <div class="avatar-icon rounded text-white bg-warning">
                            JK
                        </div>
                    </div>
                    <div class="avatar-icon-wrapper avatar-initials avatar-icon-sm">
                        <div class="avatar-icon rounded text-white bg-dark">
                            HA
                        </div>
                        <span class="badge badge-circle badge-success">Online</span>
                    </div>
                    <div class="avatar-icon-wrapper avatar-icon-sm">
                        <div class="avatar-icon rounded">
                            <img alt="..." src="assets/images/avatars/avatar2.jpg"/>
                        </div>
                    </div>
                    <div class="avatar-icon-wrapper avatar-icon-sm">
                        <div class="avatar-icon rounded">
                            <img alt="..." src="assets/images/avatars/avatar1.jpg"/>
                        </div>
                        <span class="badge badge-circle badge-warning">Idle</span>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex align-items-center bg-transparent p-2 justify-content-between">
                <div>
                    <a [routerLink]="" class="btn btn-sm btn-outline-first px-2 border-0"
                      tooltip="Actions menu"
                    >
                        <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                    </a>
                    <span class="font-size-sm text-black-50 px-2"
                         tooltip="Total downloads"
                    >
                        <fa-icon [icon]="['fas', 'link']" class="mr-1"></fa-icon>
                        55
                    </span>
                    <span class="font-size-sm text-black-50 px-2"
                         tooltip="Total views"
                    >
                        <fa-icon [icon]="['far', 'eye']" class="mr-1"></fa-icon>
                        344
                    </span>
                </div>
                <div class="font-size-sm px-2">
                    <fa-icon [icon]="['far', 'clock']" class="mr-1"></fa-icon>
                    Today - 11:35
                </div>
            </div>
        </div>
    </div>
</div>
